// extracted by mini-css-extract-plugin
export default {"root":"debug_root__nRORW","debug":"debug_debug__9DhJu","editor":"debug_editor__hMz2w","editor__header":"debug_editor__header__GBUqB"};